module.exports = __webpack_public_path__ + "img/packages/3.eb440f.png";